// 🌐 i18n — Khorezmai interfeysi tili (2.100.0, 2026-09-19).
//
// YONDASHUV — manba kodga TEGILMAYDI. UI matnlari o'zbekcha yozilaveradi (CLAUDE.md qoidasi);
// backend `scripts/i18n-extract.js` manbadan satrlarni ajratadi, `i18n-translate.js` ularni
// Claude (Max, $0) bilan o'giradi → `data/i18n/<lang>.json`, API `GET /i18n/:lang` beradi.
// Bu modul lug'atni yuklaydi va DOM'dagi matn tugunlari/atributlarni lug'at bo'yicha
// almashtiradi (MutationObserver — React qayta chizganda ham ergashadi). Lug'atda yo'q satr
// o'zbekcha qolaveradi (hech qachon buzilmaydi), yangi satr qo'shilganda faqat skriptni
// qayta yurgizish kerak — frontend build SHART EMAS.
//
// Kalit = whitespace yig'ilgan + trim qilingan o'zbek matn (extractor bilan BIR XIL).
// {0},{1} — joy tutuvchi (JSX "Jami: {n} ta", template literal, '+' zanjiri).
//
// Tegilmaydi: <script/style/code/pre/textarea>, <svg>, input qiymatlari, va
// `translate="no"` / `.notranslate` ostidagi hamma narsa (loyiha nomlari, loglar, kod).

export const LANGS = [
  { code: 'en', name: 'English',    flag: '🇬🇧' },
  { code: 'uz', name: "O'zbek",     flag: '🇺🇿' },
  { code: 'ru', name: 'Русский',    flag: '🇷🇺' },
  { code: 'es', name: 'Español',    flag: '🇪🇸' },
  { code: 'zh', name: '中文',        flag: '🇨🇳' },
  { code: 'pt', name: 'Português',  flag: '🇧🇷' },
  { code: 'fr', name: 'Français',   flag: '🇫🇷' },
  { code: 'de', name: 'Deutsch',    flag: '🇩🇪' },
  { code: 'ar', name: 'العربية',    flag: '🇸🇦' },
  { code: 'tr', name: 'Türkçe',     flag: '🇹🇷' },
];
export const DEFAULT_LANG = 'en';   // operator tanlovi (2026-09-19): standart — English
const KEY = 'kh_lang';
const API = process.env.REACT_APP_API_URL || '';

export function getLang() {
  try { const v = localStorage.getItem(KEY); if (v && LANGS.some(l => l.code === v)) return v; } catch (e) {}
  return DEFAULT_LANG;
}
export function langMeta(code) { return LANGS.find(l => l.code === code) || LANGS[0]; }

// ── lug'at ─────────────────────────────────────────────────────────────────
const cache = {};           // code → compiled dict
let cur = 'uz';             // joriy til
let dict = null;            // compiled: { plain: Map, pats: Map<bucket, [{re, order, tpl}]> }
const listeners = new Set();

const norm = (s) => String(s).replace(/\s+/g, ' ').trim();
const HAS_LETTER = /[A-Za-zÀ-ɏЀ-ӿ؀-ۿ一-鿿]/;
const escRe = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
const bucketOf = (s) => { const m = norm(s).match(/^[^\s]+/); return m ? m[0].toLowerCase() : '*'; };

function compile(t) {
  const plain = new Map(); const pats = new Map();
  for (const k of Object.keys(t)) {
    const v = t[k]; if (typeof v !== 'string' || !v) continue;
    if (/\{\d+\}/.test(k)) {
      const parts = k.split(/(\{\d+\})/).filter(p => p !== '');
      let re = '^'; const order = [];
      for (const p of parts) {
        if (/^\{\d+\}$/.test(p)) { re += '([\\s\\S]+?)'; order.push(+p.slice(1, -1)); }
        else re += escRe(p).replace(/ /g, '\\s+');
      }
      re += '$';
      const b = parts.length && !/^\{\d+\}$/.test(parts[0]) ? bucketOf(parts[0]) : '*';
      // Oldindan tekshiruv: o'zgarmas qismlar matnda bo'lmasa regex umuman yurmaydi (pastda — nega).
      const lits = parts.filter(p => !/^\{\d+\}$/.test(p)).map(p => p.replace(/\s+/g, ' ')).filter(p => p.trim());
      const head = /^\{\d+\}$/.test(parts[0]) ? '' : parts[0].replace(/\s+/g, ' ');
      const last = parts[parts.length - 1];
      const tail = /^\{\d+\}$/.test(last) ? '' : last.replace(/\s+/g, ' ');
      try { (pats.get(b) || pats.set(b, []).get(b)).push({ re: new RegExp(re), order, tpl: v, head, tail, lits }); } catch (e) {}
    } else plain.set(k, v);
  }
  return { plain, pats };
}
async function loadDict(code) {
  if (code === 'uz') return null;
  if (cache[code]) return cache[code];
  const r = await fetch(`${API}/i18n/${code}`, { credentials: 'omit' });
  if (!r.ok) throw new Error(`i18n ${code}: HTTP ${r.status}`);
  const j = await r.json();
  cache[code] = compile(j.t || {});
  return cache[code];
}

/** Bitta satrni o'giradi (whitespace chetlari saqlanadi). null = lug'atda yo'q. */
export function translate(s) {
  if (!dict || typeof s !== 'string') return null;
  const key = norm(s);
  if (!key || !HAS_LETTER.test(key)) return null;
  let out = dict.plain.get(key);
  // 🔴 Namuna regex'i ({0} → ([\s\S]+?)) uzun satrda kubik qaytish qiladi: «{0}{1}{2} oldin boshlangan» 1600 belgida 0.45 s,
  // tarjimon esa xatboshini (qatorlar + <code> bo'laklari) bitta satrga yig'adi → TezHal agenti telefonda (inglizcha) 2+ daqiqa
  // qotdi (2026-11-01). Endi: interfeys satri 1000 belgidan uzun bo'lmaydi; o'zgarmas qismlar mos kelmasa regex yurmaydi.
  if (out === undefined && key.length <= 1000) {
    const lists = [dict.pats.get(bucketOf(key)), dict.pats.get('*')];
    outer: for (const list of lists) {
      if (!list) continue;
      for (const p of list) {
        if ((p.head && !key.startsWith(p.head.trimStart())) || (p.tail && !key.endsWith(p.tail.trimEnd()))
            || !p.lits.every(l => key.includes(l.trim()))) continue;
        const m = p.re.exec(key);
        if (!m) continue;
        const vals = {}; p.order.forEach((idx, i) => { vals[idx] = m[i + 1]; });
        out = p.tpl.replace(/\{(\d+)\}/g, (_, n) => (vals[n] !== undefined ? vals[n] : ''));
        break outer;
      }
    }
  }
  if (out === undefined) return null;
  const lead = s.match(/^\s*/)[0]; const trail = s.match(/\s*$/)[0];
  return lead + out + trail;
}

// ── DOM qo'llash ────────────────────────────────────────────────────────────
const origText = new WeakMap();   // Text → asl (o'zbek) qiymat
const written = new WeakMap();    // Text → biz yozgan oxirgi qiymat
const origAttr = new WeakMap();   // Element → {attr: asl}
const writtenAttr = new WeakMap();
const ATTRS = ['title', 'placeholder', 'aria-label', 'alt'];
const SKIP = new Set(['SCRIPT', 'STYLE', 'CODE', 'PRE', 'TEXTAREA', 'NOSCRIPT', 'svg', 'SVG', 'IFRAME', 'VIDEO', 'CANVAS']);

function skipEl(el) {
  for (let e = el; e && e.nodeType === 1; e = e.parentNode) {
    if (SKIP.has(e.tagName)) return true;
    if (e.getAttribute && (e.getAttribute('translate') === 'no' || (e.classList && e.classList.contains('notranslate')))) return true;
  }
  return false;
}
function setText(node, v) { if (node.nodeValue !== v) { written.set(node, v); node.nodeValue = v; } }

/** Asl qiymat: biz yozgan bo'lsa saqlangan asl, aks holda (React yangilagan) hozirgi qiymat. */
function origOf(node) {
  const cur = node.nodeValue;
  if (written.get(node) === cur && origText.has(node)) return origText.get(node);
  origText.set(node, cur); written.delete(node);
  return cur;
}

/** Ota element darajasi: "Jami: " + {n} + " ta" kabi bo'lingan tugunlar yoki matn+<b>…</b> aralashmasi. */
function tryElement(el) {
  const kids = el.childNodes; if (!kids || kids.length < 2) return false;
  const texts = []; let concat = ''; let ph = 0; let hasText = false;
  for (const k of kids) {
    if (k.nodeType === 3) { const o = origOf(k); texts.push(k); concat += o; if (norm(o)) hasText = true; }
    else if (k.nodeType === 1) { if (k.tagName === 'BR') return false; concat += `{${ph++}}`; }
    else return false;
  }
  if (!hasText || texts.length < 1) return false;
  if (ph === 0 && texts.length < 2) return false;
  if (dict) {
    const v = translate(concat);
    if (v !== null) {
      if (ph === 0) {                       // hamma bolalar matn — birinchisiga yoz, qolganini bo'shat
        setText(texts[0], v); for (let i = 1; i < texts.length; i++) setText(texts[i], '');
        return true;
      }
      // matn + elementlar: tarjimani {i} bo'yicha bo'lib, tartib saqlangan bo'lsa joylashtiramiz
      const segs = v.split(/\{\d+\}/); const ord = (v.match(/\{(\d+)\}/g) || []).map(x => +x.slice(1, -1));
      if (ord.length !== ph || ord.some((n, i) => n !== i)) return false;
      let si = 0; const plan = [];
      for (const k of kids) {
        if (k.nodeType === 3) { plan.push([k, segs[si] || '']); segs[si] = ''; }
        else if (k.nodeType === 1) { if (norm(segs[si] || '')) return false; si++; }
      }
      if (norm(segs[si] || '')) return false;   // oxirida tugunsiz qolgan matn — tuzilma mos emas
      for (const [k, s] of plan) setText(k, s);
      return true;
    }
  }
  // lug'atda yo'q (yoki uz) → asl qiymatlarni tiklash (avvalgi til yozib qo'ygan bo'lsa)
  for (const k of texts) setText(k, origText.get(k) ?? k.nodeValue);
  return false;
}
function handleText(node) {
  const el = node.parentNode; if (!el || el.nodeType !== 1 || skipEl(el)) return false;
  const o = origOf(node);
  if (tryElement(el)) return 'el';
  if (!norm(o)) return false;
  const v = dict ? translate(o) : null;
  setText(node, v === null ? o : v);
  return true;
}
function handleAttr(el, a) {
  if (!el.hasAttribute(a)) return;
  const cur = el.getAttribute(a);
  let oa = origAttr.get(el); if (!oa) { oa = {}; origAttr.set(el, oa); }
  let wa = writtenAttr.get(el); if (!wa) { wa = {}; writtenAttr.set(el, wa); }
  if (wa[a] !== cur || !(a in oa)) { oa[a] = cur; delete wa[a]; }
  const o = oa[a];
  const v = dict ? translate(o) : null;
  const target = v === null ? o : v;
  if (cur !== target) { wa[a] = target; el.setAttribute(a, target); }
}
function handleEl(el) {
  if (skipEl(el)) return;
  for (const a of ATTRS) if (el.hasAttribute(a)) handleAttr(el, a);
  if (el.tagName === 'INPUT' && /^(submit|button)$/i.test(el.type || '') && el.hasAttribute('value')) handleAttr(el, 'value');
}
function walk(root) {
  if (!root) return;
  if (root.nodeType === 3) { handleText(root); return; }
  if (root.nodeType !== 1) return;
  const w = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT, {
    acceptNode: (n) => (n.nodeType === 1 && (SKIP.has(n.tagName) || n.getAttribute('translate') === 'no' || n.classList.contains('notranslate'))) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT,
  });
  handleEl(root);
  const doneEls = new Set();
  let n;
  while ((n = w.nextNode())) {
    if (n.nodeType === 1) handleEl(n);
    else if (!doneEls.has(n.parentNode)) { if (handleText(n) === 'el') doneEls.add(n.parentNode); }
  }
}

let observer = null;
function observe() {
  if (observer || typeof MutationObserver === 'undefined') return;
  observer = new MutationObserver((muts) => {
    for (const m of muts) {
      if (m.type === 'childList') {
        m.addedNodes.forEach(n => { if (n.nodeType === 3) handleText(n); else if (n.nodeType === 1) walk(n); });
      } else if (m.type === 'characterData') {
        const n = m.target; if (n.nodeType === 3 && written.get(n) !== n.nodeValue) handleText(n);
      } else if (m.type === 'attributes') {
        const el = m.target; const wa = writtenAttr.get(el);
        if (m.attributeName === 'value' && !(el.tagName === 'INPUT' && /^(submit|button)$/i.test(el.type || ''))) continue;
        if (!wa || wa[m.attributeName] !== el.getAttribute(m.attributeName)) handleAttr(el, m.attributeName);
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: [...ATTRS, 'value'] });
}

/** Tilni almashtirish: lug'at yuklanadi → butun DOM qayta yuriladi → tinglovchilar (UI) xabardor. */
export async function setLang(code) {
  if (!LANGS.some(l => l.code === code)) code = DEFAULT_LANG;
  try { localStorage.setItem(KEY, code); } catch (e) {}
  let d = null;
  try { d = await loadDict(code); } catch (e) { console.warn('[i18n]', e.message); if (code !== 'uz') return false; }
  cur = code; dict = d;
  document.documentElement.setAttribute('lang', code);
  if (document.body) walk(document.body);
  listeners.forEach(fn => { try { fn(code); } catch (e) {} });
  return true;
}
export function currentLang() { return cur; }
export function onLangChange(fn) { listeners.add(fn); return () => listeners.delete(fn); }

/** index.js: birinchi render'dan OLDIN chaqiriladi — lug'at tayyor bo'lsa o'zbekcha chaqnash bo'lmaydi. */
export async function initI18n({ maxWaitMs = 1500 } = {}) {
  const code = getLang();
  document.documentElement.setAttribute('lang', code);
  const start = () => { observe(); if (document.body) walk(document.body); };
  if (code === 'uz') { cur = 'uz'; dict = null; start(); return; }
  const load = loadDict(code).then(d => { cur = code; dict = d; }).catch(e => console.warn('[i18n]', e.message));
  await Promise.race([load, new Promise(r => setTimeout(r, maxWaitMs))]);
  start();
  // kech kelsa ham qo'llansin
  load.then(() => { if (dict && document.body) walk(document.body); });
}
